import HaspObject from '../Hasp/HaspObject';
import { canAddObjectToParent, isTemplatePage } from '../utils/templateObjectRules.js';
import { getObjectPage } from '../utils/hasputils';

export default class ClipboardManager {
    constructor(layer) {
        this.layer = layer;
    }

    _copySingleObject(sourceObj, uuidMap) {
        const layer = this.layer;
        let objConfig = [];
        const sourceParent = sourceObj.getParent();
        if (isTemplatePage(sourceParent)) {
            const result = canAddObjectToParent(sourceParent, sourceObj.obj);
            if (!result.valid) return [];
        }
        sourceObj.export(undefined, objConfig, true);
        const sourcePage = getObjectPage(sourceObj);
        const old2newIdMap = new Map();
        const reservedIds = new Set();
        objConfig.forEach(cfgLine => {
            old2newIdMap.set(cfgLine.id, layer.activePage.getNextId({ reservedIds }));
        });
        const createdObjects = [];
        let isFirstLine = true;
        objConfig.forEach(cfgLine => {
            const importLine = {
                ...cfgLine,
                id: old2newIdMap.get(cfgLine.id),
                parentid: cfgLine.parentid
                    ? (old2newIdMap.has(cfgLine.parentid) ? old2newIdMap.get(cfgLine.parentid) : cfgLine.parentid)
                    : undefined,
            };
            if (isFirstLine) {
                importLine.x += 10;
                importLine.y += 10;
                isFirstLine = false;
                if (sourceParent) layer.haspobject = sourceParent;
            }
            const obj = layer.importObject(importLine, { enforceTemplateRules: true });
            if (obj) {
                createdObjects.push(obj);
                const source = sourcePage?.findOne?.(node => node instanceof HaspObject && node.haspid === cfgLine.id);
                if (source) uuidMap?.set(source.id(), obj.id());
            }
        });
        return createdObjects;
    }

    /** @param {Map} [uuidMap] filled with source uuid → copy uuid, for copying related data (logic). */
    copySelectedObject(uuidMap) {
        const layer = this.layer;
        const sources = layer.selectedObjects.length > 0
            ? layer.selectedObjects.filter(o => o instanceof HaspObject)
            : (layer.haspobject instanceof HaspObject ? [layer.haspobject] : []);

        const allCreated = [];
        sources.forEach(src => {
            const created = this._copySingleObject(src, uuidMap);
            allCreated.push(...created);
        });

        layer.transformer.nodes([]);
        layer.layerCallback('mouse-down', layer.haspobject);
        return allCreated;
    }
}
